
import { computed, defineComponent, PropType } from 'vue'
import { AuditLog, useAuditLogsModule } from '@/modules/audit-logs'
import { useAPIPagination } from '@/views/_shared/search-list/pagination'
import { AuditLogsRouteNames } from '@/router/routes-names'
import { AuditLogsSearchFilter } from '@/views/_shared/search-list/types'
import { useRoute, useRouter } from 'vue-router'
import AuditLogResources from '@/components/audit-logs/audit-log-resources.vue'

export default defineComponent({
    name: 'audit-logs-list',
    components: { AuditLogResources },
    props: {
        auditLogs: {
            type: Array as PropType<AuditLog[]>
        },
        filter: {
            type: Object as PropType<AuditLogsSearchFilter>
        }
    },
    async setup (props) {
        const route = useRoute()
        const router = useRouter()
        const { getAuditLogs, auditLogsFilter, auditLogsCount } = useAuditLogsModule()

        const auditLogsColumns = ([
            { name: 'id', label: 'Id', field: 'id', sortable: true, align: 'left' },
            { name: 'operatorName', label: 'Operator name', field: (row: AuditLog) => row.operator.name, sortable: true, align: 'left' },
            { name: 'operatorOrigin', label: 'Operator origin', field: (row: AuditLog) => row.operator.origin, sortable: true, align: 'left' },
            { name: 'resources', label: 'Resources', field: 'resources', align: 'left' },
            { name: 'action', label: 'Action', field: 'action', sortable: true, align: 'left' },
            { name: 'requestId', label: 'Request id', field: 'requestId', sortable: true, align: 'left' },
            { name: 'occurrence', label: 'Occurrence', field: 'occurrence', sortable: true, align: 'left' },
            { name: 'actions', label: 'Actions', field: 'actions', align: 'left' }
        ])

        const currentPage = computed(() => route.query.page === null ? '1' : route.query.page)

        const { loading, pagination, onRequest } = useAPIPagination(auditLogsFilter, getAuditLogs, auditLogsCount, currentPage, true)

        function onShowAuditLog (evt: PointerEvent | null, props: AuditLog) {
            const routeData = router.resolve({
                name: AuditLogsRouteNames.SHOW,
                params: { id: props.id },
                query: { page: route.query.page }
            })
            window.open(routeData.href, '_blank')
        }

        await onRequest({
            filter: props.filter || {
                search: '',
                id: '',
                operatorName: '',
                operatorOrigin: '',
                action: '',
                requestId: '',
                occurrence: ''
            } as AuditLogsSearchFilter,
            pagination: pagination.value
        })

        return {
            auditLogsColumns,
            onShowAuditLog,
            loading,
            pagination,
            onRequest
        }
    }
})
